import * as yup from 'yup'

let generalSchema = yup.object({
    batch_number: yup.string().required(),
    best_before: yup.string().required(),
    quantity: yup.number().required(),
    mc_count: yup.number().required(),
})

export { generalSchema }